"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationInputState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const distance_input_state_1 = require("./distance.input.state");
const input_state_1 = require("./input.state");
const LocationField_input_state_1 = require("./LocationField.input.state");
const number_input_state_1 = require("./number.input.state");
class LocationInputState extends input_state_1.InputState {
    get value() {
        if (this.latitude.value == null || this.longitude.value == null) {
            return null;
        }
        return {
            latitude: this.latitude.value,
            longitude: this.longitude.value,
            altitude: this.altitude.value,
        };
    }
    static equal(value1, value2, precision = LocationInputState.DEFAULT_PRECISION) {
        if (value1 === value2) {
            return true;
        }
        if (value1 == null || value2 == null) {
            return false;
        }
        return (number_input_state_1.NumberInputState.equal(value1.latitude, value2.latitude, precision) &&
            number_input_state_1.NumberInputState.equal(value1.longitude, value2.longitude, precision) &&
            number_input_state_1.NumberInputState.equal(value1.altitude, value2.altitude, LocationInputState.DEFAULT_ALTITUDE_PRECISION));
    }
    constructor(label, precision = LocationInputState.DEFAULT_PRECISION, minimumInputPrecision = LocationInputState.DEFAULT_MINIMUM_INPUT_PRECISION) {
        super(label);
        this.hideZero = false;
        this._error = '';
        this.precision = precision;
        this.minimumInputPrecision = minimumInputPrecision;
        this.isLabelShown = false;
        this.latitude = new LocationField_input_state_1.LocationFieldAngleInputState(i18n_1.T.LAT, precision, minimumInputPrecision, 90);
        this.longitude = new LocationField_input_state_1.LocationFieldAngleInputState(i18n_1.T.LNG, precision, minimumInputPrecision, 180);
        this.altitude = new distance_input_state_1.DistanceInputState(i18n_1.T.FIELD_LOCATION_ALT);
    }
    setValue(val) {
        if (val == null) {
            this.latitude.setValue(null);
            this.longitude.setValue(null);
            this.altitude.setValue(null);
            return;
        }
        this.latitude.setValue(val.latitude);
        this.longitude.setValue(val.longitude);
        this.altitude.setValue(val.altitude);
    }
    hasError() {
        return super.hasError() || this.latitude.hasError() || this.longitude.hasError() || this.altitude.hasError();
    }
    get error() {
        // Don't show an error message if one is already being shown
        if (this.latitude.hasError() || this.longitude.hasError() || this.altitude.hasError()) {
            return null;
        }
        if (this.latitude.value != null && this.longitude.value == null) {
            return i18n_1.T.LONGITUDE_MISSING;
        }
        if (this.latitude.value == null) {
            return i18n_1.T.LATITUDE_MISSING;
        }
        return this._error;
    }
    set error(msg) {
        this._error = msg || '';
    }
    destroy() {
        this.latitude.destroy();
        this.longitude.destroy();
        this.altitude.destroy();
        super.destroy();
    }
}
exports.LocationInputState = LocationInputState;
LocationInputState.DEFAULT_PRECISION = 7;
LocationInputState.DEFAULT_MINIMUM_INPUT_PRECISION = 6;
LocationInputState.DEFAULT_ALTITUDE_PRECISION = 2;
tslib_1.__decorate([
    mobx_1.computed
], LocationInputState.prototype, "value", null);
tslib_1.__decorate([
    mobx_1.action
], LocationInputState.prototype, "setValue", null);
tslib_1.__decorate([
    mobx_1.computed
], LocationInputState.prototype, "error", null);
//# sourceMappingURL=location.input.state.js.map